if (document.querySelector('.jobs-result')) {

    var JobsListing = function() {
        this.mobileDomElement = document.querySelector('#filter_mobile');
        this.desktopDomElement = document.querySelector('#filters_desktop');

        this.desktopOrderingSelection = null;
        this.mobileOrderingSelection = null;
        this.jobsCountTitleElement = document.querySelector('.jobs-count-title');
        this.jobsCountElement = document.querySelector('.jobs-count-short');
        this.postLoadedCallback = null;

        this.offset = 0;
        this.offsetStep = 15;

        this.mobileFiltersDefaultTitle = 'Add filters';

        this.loadMoreJobs = function(mobileRefresh) {
            this.offset += this.offsetStep;
            this.refreshResults(mobileRefresh, true);
        }

        this.onPostsLoaded = function(content) {
            var jobsResultDom = document.querySelector('.jobs-result');
            if (this.offset > 0) {
                jobsResultDom.querySelector('.see-more-container').remove();
                jobsResultDom.innerHTML += content;
            } else {
                jobsResultDom.innerHTML = content;
            }

            if (document.querySelector('.see-more-container')) {
                var seeMoreContainerElement = document.querySelector('.see-more-container');
                seeMoreContainerElement.querySelector('.see-more-btn').addEventListener('click', this.loadMoreJobs.bind(this));
                seeMoreContainerElement.querySelector('.see-more-btn-mobile').addEventListener('click', function(){
                    this.loadMoreJobs('mobile');
                }.bind(this));
            }

            var jobsCountTitle = jobsResultDom.querySelector('#jobs-count-title').value;
            var jobsCountShort = jobsResultDom.querySelector('#jobs-count-short').value;
            if (jobsCountTitle) this.jobsCountTitleElement.innerHTML = jobsCountTitle;
            if (jobsCountShort) this.jobsCountElement.innerHTML = jobsCountShort;
            if (this.postLoadedCallback) {
                this.postLoadedCallback();
            }
            var loadingDom = document.querySelector('.loading-box');
            loadingDom.classList.add('done');
        }

        this.updateMobileFiltersTitle = function() {
            var filtersTitleElement = document.querySelector('.add-filters');
            var categorySelectedElements = this.mobileDomElement.querySelectorAll('.category-selected');
            var filtersAppliedCount = categorySelectedElements.length;

            if (filtersAppliedCount > 0) {
                filtersTitleElement.parentElement.querySelector('.filters-count').innerHTML = ' Filter' + ((filtersAppliedCount > 1) ? 's' : '') + ' (' + filtersAppliedCount + ')';
                filtersTitleElement.parentElement.querySelector('.filters-count').classList.add('filters-applied');
                filtersTitleElement.querySelector('.add-filters-text').innerHTML = 'Edit';
                filtersTitleElement.querySelector('.add-filters-icon').classList.add('hidden');
                filtersTitleElement.querySelector('.edit-filters-icon').classList.remove('hidden');
            } else {
                filtersTitleElement.parentElement.querySelector('.filters-count').innerHTML = '';
                filtersTitleElement.parentElement.querySelector('.filters-count').classList.remove('filters-applied');
                filtersTitleElement.querySelector('.add-filters-text').innerHTML = this.mobileFiltersDefaultTitle;
                filtersTitleElement.querySelector('.add-filters-icon').classList.remove('hidden');
                filtersTitleElement.querySelector('.edit-filters-icon').classList.add('hidden');
                filtersTitleElement.classList.remove('filters-applied');
            }
        }

        this.toggleClearIcon = function(event) {
            var element = (event instanceof Event) ? event.target : event; // Check if called manually

            var clearIcon = element.parentElement.querySelector('.clear-icon');
            if (element.value.length > 0) {
                if (clearIcon.classList.contains('hidden'))
                    clearIcon.classList.remove('hidden');
            } else {
                if (!clearIcon.classList.contains('hidden'))
                    clearIcon.classList.add('hidden');
            }
        }

        this.clearSearchInput = function(event) {
            var searchInputs = document.querySelectorAll('.job-keyword-input');
            for (var i = 0; i < searchInputs.length; i++) {
                searchInputs[i].value = '';
            }
            event.target.classList.add('hidden');
            if (event.target.classList.contains('mobile')) {
                this.refreshResults('mobile');
            } else {
                this.refreshResults();
            }
        }

        this.clearMobileFilters = function() {
            if (sectorCategoriesMobile) sectorCategoriesMobile.clearModifications();
            if (salaryCategoriesMobile) salaryCategoriesMobile.clearModifications();
            if (contractCategoriesMobile) contractCategoriesMobile.clearModifications();
            if (favoriteCategoriesMobile) favoriteCategoriesMobile.clearModifications();
            this.updateMobileFiltersTitle();
            this.refreshResults('mobile');
        }

        this.getFilters = function(dropdownElement) {
            var selectedFiltersElements = dropdownElement.querySelectorAll('.category-checkbox:checked');
            var selectedSlugs = [];
            for (var i = 0; i < selectedFiltersElements.length; i++) {
                selectedSlugs[i] = selectedFiltersElements[i].value;
            }
            return selectedSlugs.join(',');
        }

        this.refreshResults = function(mobileRefresh, keepOffset) {
            keepOffset = keepOffset || false;
            if (!keepOffset) {
                this.offset = 0;
            }

            var domSelector = (mobileRefresh == 'mobile') ? this.mobileDomElement : this.desktopDomElement;
            var searchDomSelector = (mobileRefresh == 'mobile') ? document.querySelector('.search-form-mobile') : document.querySelector('.search-form');
            var orderSelection = (mobileRefresh == 'mobile') ? this.mobileOrderingSelection : this.desktopOrderingSelection;

            var searchDomElement = searchDomSelector.querySelector('.job-keyword-input');
            var sectorsFilterElement = domSelector.querySelector('.sector-dropdown');
            var salaryFilterElement = domSelector.querySelector('.salary-dropdown');
            var contractFilterElement = domSelector.querySelector('.contract-dropdown');
            var favoriteFilterCheckboxElement = domSelector.querySelector('.favorite-dropdown .checkbox');

            var requestData = {
                action: 'load_jobs'
            };
            var urlParams = {};

            if (searchDomElement.value) {
                requestData.search = searchDomElement.value;
                urlParams.job_term = searchDomElement.value;
            }
            if (orderSelection) {
                requestData.order = orderSelection.selectedOption;
                urlParams.order = orderSelection.selectedOption;
            }
            if (sectorsFilterElement) {
                var sectorFilters = this.getFilters(sectorsFilterElement);
                if (sectorFilters != '') {
                    requestData.filters = requestData.filters || {};
                    requestData.filters.sectors = sectorFilters;
                    urlParams.sectors = sectorFilters;
                }
            }
            if (salaryFilterElement) {
                var salaryFilters = this.getFilters(salaryFilterElement);
                if (salaryFilters != '') {
                    requestData.filters = requestData.filters || {};
                    requestData.filters.salary = salaryFilters;
                    urlParams.salary = salaryFilters;
                }
            }
            if (contractFilterElement) {
                var contractFilters = this.getFilters(contractFilterElement);
                if (contractFilters != '') {
                    requestData.filters = requestData.filters || {};
                    requestData.filters.contractTypes = contractFilters;
                    urlParams.contract_type = contractFilters;
                }
            }
            if (favoriteFilterCheckboxElement) {
                var onlyFavorite = favoriteFilterCheckboxElement.checked;
                if (onlyFavorite) {
                    requestData.favoriteOnly = true;
                    urlParams.only_favorites = true;
                }
            }
            if (this.offset > 0) {
                requestData.offset = this.offset;
                urlParams.offset = this.offset;
            }

            if (mobileRefresh == 'mobile') {
                this.updateMobileFiltersTitle();
            }

            var jobsResultDom = document.querySelector('.jobs-result');
            if (keepOffset) {
                var btnSelector = (mobileRefresh == 'mobile') ? jobsResultDom.querySelector('.see-more-btn-mobile') : jobsResultDom.querySelector('.see-more-btn');
                btnSelector.classList.add('disabled');
                btnSelector.innerHTML = 'LOADING ...';
            } else {
                jobsResultDom.innerHTML = '';
            }


            var loadingDom = document.querySelector('.loading-box');
            loadingDom.classList.remove('done');

            var ajaxLoad = new AjaxRequest(this.onPostsLoaded.bind(this), function(error) {console.log(error);});
            ajaxLoad.post(ajaxurl, null, requestData);
            history.replaceState(null, null, '?' + jQuery.param(urlParams));
        }

        this.bindEvents = function() {
            var refreshBtnList = document.querySelectorAll('.refresh-jobs');
            for (var i = 0; i < refreshBtnList.length; i++) {
                refreshBtnList[i].addEventListener('click', this.refreshResults.bind(this));
            }

            var mobileRefreshBtnList = document.querySelectorAll('.refresh-jobs-mobile');
            for (var i = 0; i < mobileRefreshBtnList.length; i++) {
                mobileRefreshBtnList[i].addEventListener('click', function(){this.refreshResults('mobile')}.bind(this));
            }

            var searchFormDesktop = document.querySelector('.search-form');
            var searchFormMobile = document.querySelector('.search-form-mobile');
            var searchInputDesktop = searchFormDesktop.querySelector('.job-keyword-input');
            var searchInputMobile = searchFormMobile.querySelector('.job-keyword-input');

            var desktopClearIcon = searchFormDesktop.querySelector('.clear-icon');
            desktopClearIcon.addEventListener('click', this.clearSearchInput.bind(this));
            var mobileClearIcon = searchFormMobile.querySelector('.clear-icon');
            mobileClearIcon.addEventListener('click', this.clearSearchInput.bind(this));

            searchInputDesktop.addEventListener('input', this.toggleClearIcon.bind(this));
            searchInputMobile.addEventListener('input', this.toggleClearIcon.bind(this));
            this.toggleClearIcon(searchInputDesktop);
            this.toggleClearIcon(searchInputMobile);

            searchFormDesktop.addEventListener('submit', function(event){
                event.preventDefault();
                this.refreshResults();
            }.bind(this));
            searchFormMobile.addEventListener('submit', function(event){
                event.preventDefault();
                this.refreshResults('mobile');
            }.bind(this));

            if (document.querySelector('.clear-filters')) {
                document.querySelector('.clear-filters').addEventListener('click', this.clearMobileFilters.bind(this));
            }
        }

        this.init = function() {
            this.bindEvents();
            window.addEventListener('load', () => {
                this.refreshResults();
                this.updateMobileFiltersTitle();
            }, false);
        }

        this.init();
    }

    var jobsListingManager = new JobsListing();
}
